import './listEtudiant.css'
import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import CardEtudiant from './CardEudiant-prof/CardEtudiant';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db, getDocument } from '../../../Firebase';
import { SamaDate } from '../../../Services';
import { Row } from 'react-bootstrap';



export default function ListEtudiant() {
  const [students, setStudents] = useState([])
  const [userCurrent, setUserCurrent] = useState({});

  const reftab = query(collection(db, "users"));

  const currentUserId = sessionStorage.getItem("user_id")

  const getStudents = () => {
    const data = []
    onSnapshot(reftab, (item) => {
      item.forEach((donne) => {
        data.push({ ...donne.data(), id: donne.id })
      })
      setStudents(data);
    })
  }

  useEffect(() => {
    getStudents();
    getDocument("users", currentUserId, setUserCurrent)
  }, [currentUserId]);

  const mes_etudiants = students.filter((item) => item.domaine === userCurrent.domaine.toLowerCase() &&
   item.admin_id === userCurrent.admin_id && item.user_type === "etudiant")


  const [filter, setFilter] = useState("");

  const handelChange = (e) => {
    setFilter(e.target.value.toLowerCase());
  };


  return (

    <div className="etudiant-dasbord container-fluid py-3 ">
      <h3 className="pt-2 ">ETUDIANTS
        <hr />
      </h3>
      <div className='d-flex justify-content-end'>
        <Form.Control className='recherhe' onChange={handelChange}
              value={filter} type="text" placeholder=" Recherche un etudiant" />
      </div>
      
      <Row>
        {
          mes_etudiants.map(({ nom, residence, registeredAt, prenom ,domaine }, index) => {
            if (nom.toLowerCase().indexOf(filter) !== -1 ||
            prenom.toLowerCase().indexOf(filter) !== -1 )
            return <CardEtudiant
              nom={nom}
              prenom={prenom}
              adresse={residence}
              date={<SamaDate mydate={registeredAt} />}
              domaine ={domaine}
              key={index}
            />

          }
          )
        }
      </Row>
    </div>
  )
}
